import React, { HTMLAttributes, useCallback, useContext } from 'react'
import OfferFilterSelectBox from '../OfferFilterSelectBox'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import OfferPageStateTrackingContext from 'contexts/OfferPage/offerPageStateTrackingContext'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'

interface Props extends HTMLAttributes<HTMLButtonElement> {
  airport?: App.Airport;
  offer?: App.Offer;
  activeFilter?: string;
  offerType: App.LEContractedAnalyticsType;
  inSidebar?: boolean;
  iconDisabled?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
}

function OfferAirportSelectBox(props: Props) {
  const {
    airport,
    activeFilter,
    offerType,
    offer,
    iconDisabled,
    ...rest
  } = props

  const dispatch = useOfferPageDispatch()
  const isOpen = activeFilter === 'airport'
  const { trackEvent } = useContext(OfferPageStateTrackingContext)

  const onBoxClick = useCallback(() => {
    if (isOpen) {
      dispatch({ type: OfferPageActions.closeFilter })
      trackEvent('AIRPORT_FILTER_CLOSED')
    } else {
      dispatch({ type: OfferPageActions.toggleFilter, filter: 'airport' })
      trackEvent('AIRPORT_FILTER_PRESSED')
    }
  }, [isOpen, dispatch, trackEvent])

  return (<OfferFilterSelectBox
    {...rest}
    data-testid="origin-select"
    onClick={onBoxClick}
    active={isOpen}
    icon={!iconDisabled && <LinePlaneDepartureIcon />}
    label={`Departure airport ${offer?.bundledWithFlightsOnly ? '' : '(optional)'}`}
    value={airport ? <b>{airport.name} ({airport.code.toUpperCase()})</b> : undefined}
    placeholder="Select by airport"
  />
  )
}

OfferAirportSelectBox.displayName = 'OfferAirportSelectBox'

export default withOfferPageState((state) => ({
  airport: state.airport,
  activeFilter: state.activeFilter,
  offer: state.offer,
  offerType: state.offer?.analyticsType || state.bedbankOffer?.analyticsType,
}), OfferAirportSelectBox)
